// extracted by mini-css-extract-plugin
export default {"loaderWrap":"Loader_loaderWrap__5Ipoy","loaderContainer":"Loader_loaderContainer__jbTI2"};